import { render, staticRenderFns } from "./CResults.vue?vue&type=template&id=a260c9d6&"
import script from "./CResults.vue?vue&type=script&lang=js&"
export * from "./CResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports